import { useEffect, useState } from "react";

import { IMedia } from "@/interfaces/media.interface";
import mediaService from "@/services/midia.service";

export default function useDownloadMedia({ _id, _media }: { _id: number; _media: IMedia | null }) {
  const [mediaURL, setMediaURL] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    async function downloadMedia() {
      setIsLoading(true);

      if (!_id || !_media) return;

      const cache = await caches.open("media-cache");
      const cachedResponse = await cache.match(`media-${_id}`);

      if (cachedResponse) {
        const blob = await cachedResponse.blob();
        const reader = new FileReader();

        reader.onloadend = function () {
          if (reader.result) {
            setMediaURL(reader.result as string);
            setIsLoading(false);
          }
        };

        reader.readAsDataURL(blob);
      } else {
        try {
          const dataUrl = await mediaService.download(_id, _media);
          const byteCharacters = atob(dataUrl.split(",")[1]);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: dataUrl.split(":")[1].split(";")[0] });

          await cache.put(`media-${_id}`, new Response(blob));
          setMediaURL(dataUrl);
          setIsLoading(false);
        } catch (error) {
          setIsLoading(false);
          throw new Error("Erro ao baixar a mídia");
        }
      }
    }

    downloadMedia();
  }, [_id, _media]);

  return { mediaURL, isLoading };
}
